// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1V4iF","col":"styles_col__1NYYW"};